import BigNumber from 'bignumber.js'
import nftLaunchpadFactoryABI from 'config/abi/nftLaunchpadFactory.json'
import dmdABI from 'config/abi/dmd.json'
import { multicallWithAbi } from 'utils/multicall'
import { getDmdAddress, getNftLaunchpadFactoryAddress, getNftLaunchpadFactoryV2Address } from 'utils/addressHelpers'

const fetchLaunchpadIsWhitelisted = async (account) => {
  const calls = [
    {
      address: getNftLaunchpadFactoryAddress(),
      name: 'isWhitelisted',
      params: [account],
      abi: nftLaunchpadFactoryABI,
    },
    {
      address: getNftLaunchpadFactoryV2Address(),
      name: 'isWhitelisted',
      params: [account],
      abi: nftLaunchpadFactoryABI,
    },
    {
      address: getDmdAddress(),
      name: 'allowance',
      params: [account, getNftLaunchpadFactoryV2Address()],
      abi: dmdABI,
    },
  ]
  const [isWhitelistedFC, isWhitelistedV2FC, allowanceFC] = await multicallWithAbi(calls)

  return {
    v1: {
      isWhitelisted: isWhitelistedFC[0],
    },
    v2: {
      isWhitelisted: isWhitelistedV2FC[0],
      allowance: new BigNumber(allowanceFC[0]._hex),
    },
  }
}

export default fetchLaunchpadIsWhitelisted
